import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-lock-shuffle",
  "use": "foquz-icon-lock-shuffle-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol viewBox=\"0 0 16 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-lock-shuffle\"><path d=\"M12 7.5H4m8 0c1.7 0 3 1.302 3 2.91v3.09c0 1.607-1.3 3-3 3H3.91c-1.607 0-2.91-1.393-2.91-3v-3.09C1 8.801 2.3 7.5 4 7.5m8 0v-2c0-2.41-1.59-4-4-4s-4 1.59-4 4v2m4.5 6h-1l.5-3 .5 3z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol